import { createContext, useContext } from 'react';

export type PanelGroupContextValue<T> = {
  activeValue: T | null;
  onChange: (value: T) => void;
};

export const PanelGroupContext =
  createContext<PanelGroupContextValue<unknown> | null>(null);

export const usePanelGroupContext = <T = string,>() => {
  const context = useContext(PanelGroupContext);

  if (!context) {
    throw new Error('usePanelGroupContext must be used within a PanelGroup');
  }

  return context as PanelGroupContextValue<T>;
};
